import { ModalidadeFundamentacao } from "./modalidade-fundamentacao.model";

export class Visibilidade {

    id?: number;

    label?: string;

    tipo?: string;

    valor?: string;

    poderes?: string[];

    modalidadeFundamentacao?: ModalidadeFundamentacao;

    fundamentacao?: string;

    criadoPor?: string;

    constructor() {
        this.id = null;
        this.label = null;
        this.tipo = null;
        this.valor = null;
        this.poderes = [];
        this.modalidadeFundamentacao = null;
        this.fundamentacao = null;
        this.criadoPor = null;
    }
}
